import { render, staticRenderFns } from "./MergeMemberForm.vue?vue&type=template&id=13e8d1f3"
import script from "./MergeMemberForm.vue?vue&type=script&lang=js"
export * from "./MergeMemberForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports